import React, {useEffect, useState} from 'react';
import {Box, Button, Grid, MenuItem, TextField, Typography} from '@mui/material';
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import CheckinsGrid from "./CheckinsGrid";

const CheckinSchedule = ({defendantId, checkinSchedule, onGenerateCheckins}) => {
    const [frequency, setFrequency] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [checkins, setCheckins] = useState([]);

    useEffect(() => {
        if (!!checkinSchedule) {
            setFrequency(checkinSchedule.frequency);
            setStartDate(dayjs(checkinSchedule.startDate));
            setEndDate(dayjs(checkinSchedule.endDate));
            setCheckins(checkinSchedule.checkins);
        }
    }, [checkinSchedule]);

    const generateCheckins = () => {
        if (!startDate || !endDate || !frequency) return;

        const start = dayjs(startDate);
        const end = dayjs(endDate);
        const newCheckins = [];
        let current = start;
        let index = 0;
        while (current.isBefore(end) || current.isSame(end)) {
            newCheckins.push({
                date: current.toDate(),
                isCompleted: false,
                status: 'Pending',
                notes: '',
                photoUrl: '',
                id: index,
            });

            switch (frequency) {
                case 'Daily':
                    current = current.add(1, 'day');
                    break;
                case 'Weekly':
                    current = current.add(1, 'week');
                    break;
                case 'Monthly':
                    current = current.add(1, 'month');
                    break;
                default:
                    break;
            }
            index++;
        }

        setCheckins(newCheckins);
        const schedule = {startDate: start, endDate: end, frequency: frequency, checkins: newCheckins}
        onGenerateCheckins(schedule)
    };


    return (
        <Box sx={{ maxWidth: '100%', mt: 2}}>
            <Typography variant="h5" gutterBottom>
                Check-in Schedule
            </Typography>
            <Box noValidate sx={{mt: 2}}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <DatePicker
                            fullWidth
                            label="Start Date"
                            value={startDate}
                            onChange={(newValue) => setStartDate(newValue)}
                            renderInput={(params) => <TextField {...params} fullWidth/>}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <DatePicker
                            fullWidth
                            label="End Date"
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            renderInput={(params) => <TextField {...params} fullWidth/>}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label="Frequency"
                            value={frequency}
                            onChange={(e) => setFrequency(e.target.value)}
                            select
                            fullWidth
                        >
                            <MenuItem value="Daily">Daily</MenuItem>
                            <MenuItem value="Weekly">Weekly</MenuItem>
                            <MenuItem value="Monthly">Monthly</MenuItem>
                        </TextField>
                    </Grid>
                </Grid>
                <Box sx={{mt: 3}}>
                    {checkins.length === 0 && (
                    <Button variant="contained" color="primary" fullWidth onClick={generateCheckins}>
                        Generate Checkins
                    </Button>
                    )}
                </Box>
            </Box>
            <CheckinsGrid checkins={checkins}/>
        </Box>
    );
};

export default CheckinSchedule;
